// Espera a que la página cargue completamente para encontrar el botón
document.addEventListener('DOMContentLoaded', function() {
    
    var button = document.getElementById('size-chart-button');
    var modal = document.getElementById('size-chart-modal');
    var closeBtn = document.querySelector('#size-chart-modal .close-button');
    var body = document.body; // Referencia al <body> para bloquear el scroll
  
    // Solo si encontramos ambos elementos, configuramos los listeners
    if (button && modal) {
      
      // Función para abrir el modal
      button.addEventListener('click', function() {
        modal.style.display = 'block';
        body.classList.add('modal-open'); // AÑADE CLASE PARA BLOQUEAR SCROLL
      });
  
      // Función para cerrar el modal
      var closeModal = function() {
          modal.style.display = 'none';
          body.classList.remove('modal-open'); // REMUEVE CLASE PARA RESTAURAR SCROLL
      };

      // Cierra el modal con la X
      if (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
      }

      // Cierra el modal al hacer clic fuera del contenido
      window.addEventListener('click', function(event) {
        if (event.target == modal) {
          closeModal();
        }
      });
    }
});